import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SIRSIC_TBL;

export default {
  read(payload) {
    return baseApi.post(resource, payload);
  },
};
